// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { QTAlignment } from '../elements/QuickTable/QuickTableColumn';
import { BaseItem, ColumnData } from './BaseItem';
import { ColumnParams } from './ColumnParams';
import { TableTotalsVisibility } from './TableTotalsVisibility';
export class HolidayItem extends BaseItem {
    constructor(date, name, shedule) {
        super(null);
        this.date = date;
        this.name = name;
        this.shedule = shedule;
    }
    ColumnCount() {
        return HolidayItem.columnsParams.length;
    }
    GetColumnParams(column) {
        const par = HolidayItem.columnsParams[column];
        par.Hidden = par.DefaultHidden;
        return par;
    }
    getColumnData(column) {
        const val = this.getColumnValue(column);
        return new ColumnData(val, val ? val.toString() : '');
    }
    getColumnValue(column) {
        switch (column) {
            case 0:
                return this.date;
            case 1:
                return this.name;
            case 2:
                return this.shedule;
            default:
                return null;
        }
    }
}
HolidayItem.columnsParams = [
    new ColumnParams('InstrumentDetailsPanel.HolidayDate', 40, QTAlignment.Left, TableTotalsVisibility.All, true, true),
    new ColumnParams('InstrumentDetailsPanel.HolidayName', 40, QTAlignment.Left, TableTotalsVisibility.All, true, true),
    new ColumnParams('InstrumentDetailsPanel.HolidayType', 40, QTAlignment.Left, TableTotalsVisibility.All, true, true)
];
